module.exports = __webpack_public_path__ + "static/img/kgff.cde80b84.png";